import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { db } from "@/api/base44Client";
import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus, Mail, Lock, User, Loader2, Gift } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import GoogleIcon from "@/components/GoogleIcon";
import { safeReturnTo } from "@/lib/authReturnTo";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser, setIsAuthenticated } = useAuth();
  const navigate = useNavigate();
  const returnTo = safeReturnTo();
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("ref");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await db.auth.registerEmail(email, password, name, referralCode);
      setUser(u);
      setIsAuthenticated(true);
      navigate(returnTo === "/" ? "/faecher" : returnTo, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Registrierung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout icon={UserPlus} title="Konto erstellen" subtitle="Registriere dich, um zu starten"
      footer={<>Bereits ein Konto?{" "}<Link to={"/login" + (returnTo !== "/" ? "?returnTo=" + encodeURIComponent(returnTo) : "")} className="text-primary font-medium hover:underline">Anmelden</Link></>}>
      <Button variant="outline" className="w-full h-12 text-sm font-medium mb-6" onClick={() => db.auth.loginWithProvider()}>
        <GoogleIcon className="w-5 h-5 mr-2" /> Mit Google fortfahren
      </Button>
      <div className="relative mb-6"><div className="absolute inset-0 flex items-center"><div className="w-full border-t border-border" /></div><div className="relative flex justify-center text-xs uppercase"><span className="bg-card px-3 text-muted-foreground">oder</span></div></div>
      {referralCode && (
        <div className="mb-4 p-3 rounded-lg bg-green-50 border border-green-200 text-green-800 text-sm flex items-center gap-2">
          <Gift className="w-4 h-4 shrink-0" />
          <span>Du registrierst dich via Freunde-Einladung. Wir beide bekommen Belohnungen!</span>
        </div>
      )}
      {error && <div className="mb-4 p-3 rounded-lg bg-destructive/10 text-destructive text-sm">{error}</div>}
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-2"><Label htmlFor="name">Name</Label><div className="relative"><User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="name" autoFocus placeholder="Dein Name" value={name} onChange={(e) => setName(e.target.value)} className="pl-10 h-12" /></div></div>
        <div className="space-y-2"><Label htmlFor="email">E-Mail</Label><div className="relative"><Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="email" type="email" placeholder="du@example.com" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-12" required /></div></div>
        <div className="space-y-2"><Label htmlFor="password">Passwort</Label><div className="relative"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="password" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-12" required /></div></div>
        <Button type="submit" className="w-full h-12 font-medium" disabled={loading}>{loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Konto wird erstellt...</> : "Konto erstellen"}</Button>
      </form>
    </AuthLayout>
  );
}
